/**
 * Created by Prodaja1 on 12.5.2017..
 */
import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { Question2 } from '../question2/question2';
import {UserData} from "../services/UserData";
import { AlertController } from 'ionic-angular';


@Component({
    selector: 'question1',
    templateUrl: 'question1.html'
})
export class Question1 {
    userData: UserData
    constructor(public navCtrl: NavController, navParams: NavParams, private alertCtrl: AlertController) {
        this.userData = navParams.data;
    }

    checkCommentInput() {
        if (this.userData.answer1a!="Nezadovoljni") {
            this.userData.answer1b = '';
            return true;
        }
        else {
            return false;

        }
    }

    checkGradesValues () {
        if (this.userData.answer1a=='')
        {
            let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Please select one of the options',
                buttons: ['OK']
            });
            alert.present();
        }
        else { //ako je oznaceno nesto od bulleta provjeri je li oznacen not satisfied.. Ako je onda je komentar obavezan, a ako nije onda ide na sljedecu stranicu
            if (this.userData.answer1a=='Nezadovoljni') {
                if (this.userData.answer1b=='') {
                    let alert = this.alertCtrl.create({
                        title: 'Error!',
                        subTitle: 'Please state a reason',
                        buttons: ['OK']
                    });
                    alert.present();
                }
                else {
                    this.navCtrl.push(Question2, this.userData);
                }
            }
            else {
                this.navCtrl.push(Question2, this.userData);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/question1/question1.ts